import { inject, Injectable, Signal } from '@angular/core';
import { httpResource } from '@angular/common/http';
import { BASE_URL } from '@teamfoster/sdk/ssr';
import { ProductReviewsResult } from '../models/product-review.model';
import { JudgeMeWidgetResponse } from '../models/judge-me-widget-response.model';
import { JudgeMeJsonResponse } from '../models/judge-me-json-response.model';

@Injectable({
  providedIn: 'root',
})
export class ProductReviewsService {
  #baseUrl = inject(BASE_URL);

  getReviewsByHandle(handle: Signal<string>, perPage: Signal<number>) {
    return httpResource<ProductReviewsResult>(() => {
      if (!handle()) {
        return undefined;
      }
      return {
        url: `${this.#baseUrl}api/products/${handle()}/reviews`,
        params: {
          perPage: perPage() || 5,
        },
      };
    });
  }

  getReviewHtmlByHandle(handle: Signal<string>, perPage: Signal<number>) {
    return httpResource<JudgeMeWidgetResponse>(() => {
      if (!handle()) {
        return undefined;
      }
      return {
        url: `${this.#baseUrl}api/products/${handle()}/reviews/widget`,
        params: {
          perPage: perPage() || 5,
        },
      };
    });
  }

  getReviewJsonByHandle(handle: Signal<string>, perPage: Signal<number>, page: Signal<number>) {
    return httpResource<JudgeMeJsonResponse>(() => {
      if (!handle()) {
        return undefined;
      }
      return {
        url: `${this.#baseUrl}api/products/${handle()}/reviews/json`,
        params: {
          perPage: perPage() || 5,
          page: page() || 1,
        },
      };
    });
  }
}
